import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePermission } from "../helper/authHelper";

////Diego Fernando Sandoval Figueroa
////20/08/2025
////Función que me permite evaluar si el usuario que ingreso es admin o no, para redirigir a rutas privadas o publicas
export function ProtectedRoute({ isAllowed, redirectPath = "/home" }) {
    if (!isAllowed)
        return <Navigate to={redirectPath} replace />;

    return <Outlet />; ///Se utiliza cuando son varias rutas las cuales debemos de proteger de acuerdo al rol del usuario
}

export function PermissionRoute({ permiso, children, redirectPath = "/home" }){
    const permisos = usePermission(permiso);

    const allGranted = Object.values(permisos).every(Boolean);

    if (!allGranted)
        return <Navigate to={redirectPath} replace />;

    return children;
}

export function LayoutNotMenu(){
    const location = useLocation();

    const ocultarEn = ["/Seguridad/ConfirmaBaja"];

    return (
        <>
            {ocultarEn.includes(location.pathname) ? null : <Outlet />}
        </>
    )
}